import { axiosNodeClient } from "../config/axiosNodeClient"

const nodeApiService = () => ({
  artworks: (params) => {
    return axiosNodeClient.get("artworks", { params })
  },
  galleryArtworks: (id, params) => {
    return axiosNodeClient.get(`galleries/${id}/artworks`, { params })
  },
  galleryArtworksByCollection: (id, collection_slug, params = {}) =>
    axiosNodeClient.get(
      `galleries/${id}/collections/${encodeURIComponent(collection_slug)}`,
      {
        params,
      },
    ),
  gallery: (id) => axiosNodeClient.get(`galleries/${id}`),
  galleries: (params) => {
    return axiosNodeClient.get("galleries", { params })
  },
  search: (params) => {
    return axiosNodeClient.get("search", { params })
  },
  spaces: (params) => {
    return axiosNodeClient.get("spaces", { params })
  },
  contact: (body) => {
    return axiosNodeClient.post("contact", body)
  },
  dataCapture: (galleryId, body) => {
    return axiosNodeClient.post(`galleries/${galleryId}/datacapture`, body)
  },
  contactGallery: (galleryId, body) => {
    return axiosNodeClient.post(`galleries/${galleryId}/contact`, body)
  },
  inquire: (artworkId, body) => {
    return axiosNodeClient.post(`artworks/${artworkId}/inquire`, body)
  },
  purchase: (artworkId, body) => {
    return axiosNodeClient.post(`artworks/${artworkId}/purchase`, body)
  },
  exhibitions: (params) => {
    return axiosNodeClient.get("exhibitions", { params })
  },
})

export default nodeApiService()
